export default __webpack_public_path__ + "Open_Roll_Small_Single.png";